import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import { DetailsPopover } from '../detailsPopover';

const useStyles = makeStyles(theme => ({
    underline: {
        textDecoration: ({ textType } : any ) => textType === 'string' ? 'underline' : 'none',
        color: "#2739c1",
    },
 
}));

export default function PopoverLink({ rowData = undefined, columnData, customClasses = '', hoverData=undefined, title = '', tabIndex = undefined, maxWidth = 300,
    anchorOrigin = null, transformOrigin = null, primary=false
 }) {
    
    const [anchorEl, setAnchorEl] = useState(null);
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [popoverTitle, setPopoverTitle] = useState('');
    const classes = useStyles({ textType: typeof columnData });


    function handleHoverColumn(event, rowData) {
        setAnchorEl(event?.target);
        setPopoverTitle(title);
        setIsPopoverOpen(true);
    }

    function popoverLeave() {
        setIsPopoverOpen(false);
    }

    function paperEnter() {
        setIsPopoverOpen(true);
    }


    return (
        <>
            <Link
                to=""
                onClick={(e) => e.preventDefault()}
                aria-owns={`${columnData}-mouse-over-popover`}
                aria-haspopup="true"
                onMouseEnter={(event) => handleHoverColumn(event, rowData)}
                onMouseLeave={popoverLeave}
                className={` ${customClasses} ${classes.underline}`}
                tabIndex={tabIndex}
            >
                {
                    primary ? rowData?.isPrimaryCpt ? (
                        <strong>{columnData}</strong>
                    ) : (
                        <span>{columnData}</span>
                    ) : (
                        <span>{columnData}</span>
                    )
                }
            </Link>
           {hoverData && <DetailsPopover
                items={hoverData}
                title={popoverTitle}
                isPopoverOpen={isPopoverOpen}
                anchorEl={anchorEl}
                maxWidth={maxWidth}
                anchorOrigin={anchorOrigin}
                transformOrigin={transformOrigin}
                actions={{
                    popoverLeave,
                    paperEnter
                }}
            />}
        </>
    );
}